import classnames from 'classnames';

import styles from './Card.module.scss';
import { CardProps } from './Card.types';

export const Card = ({
  className,
  children,
  color,
  error,
  containerClassName,
  cardClassName,
  ...props
}: CardProps) => (
  <div className={classnames(styles.container, containerClassName)}>
    <div
      className={classnames(
        styles.card,
        styles[color],
        className,
        error && styles.error,
        cardClassName
      )}
      {...props}
    >
      {children}
    </div>
  </div>
);
